export default "__VITE_ASSET__COZPtZU1__"